<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					@submit.native.prevent
        >
          <el-form-item label="院校名称:">
            <el-input 
							v-model.trim="searchForm.collegename" 
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
			stripe
			border
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="院校名称" prop="collegename" align="center" />
      <el-table-column label="函授站名称" prop="schoolorgname" align="center" />
      <el-table-column label="上课点名称" prop="classname" align="center" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
			:close-on-click-modal='false'
      :width="$store.state.global.isFullscreen ? 'width: 100%' : 'width: 80%'"
      :fullscreen="$store.state.global.isFullscreen"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
      @closed="$store.state.global.isFullscreen = false"
    >
      <span slot="title" class="el-dialog__title">
        <span>{{ dialogTitle }}</span>
        <span
          :class="
            $store.state.global.isFullscreen
              ? 'el-icon-copy-document'
              : 'el-icon-full-screen'
          "
          @click="isExpand($store.state.global.isFullscreen)"
        ></span>
      </span>
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
        <el-form-item label="流水号:">
          {{ dynamicValidateForm.id }}
        </el-form-item>
        <el-form-item label="学院代码:">
          {{ dynamicValidateForm.code }}
        </el-form-item>
        <el-form-item label="院校名称:">
          {{ dynamicValidateForm.name }}
        </el-form-item>
        <el-form-item label="LOGO:">
          <img
            :src="$url.upload + dynamicValidateForm.logourl"
            alt=""
            class="picture"
          />
        </el-form-item>
        <el-form-item label="可用标志:">
          {{ enableflag[dynamicValidateForm.enableflag] }}
        </el-form-item>
        <el-form-item label="排序权重:">
          {{ dynamicValidateForm.rank }}
        </el-form-item>
        <el-form-item label="院校简介:">
          {{ dynamicValidateForm.brief }}
        </el-form-item>


        <table border="1" cellpadding="10" cellspacing="0" v-if="dynamicValidateForm.list.length">
          <tr>
            <td>层次</td>
            <td>招生专业</td>
            <td>学制</td>
          </tr>
          <tr v-for="item,i in dynamicValidateForm.list" :key="i">
            <td>{{item.majorlevelval}}</td>
            <td>{{item.collegename}}</td>
            <td>{{item.xuezhi}}</td>
          </tr>
        </table>

      </el-form>
    </el-dialog>
		<el-dialog 
			class="btn-2b5a95"
			width="50%"
			v-dialogDrag
			:close-on-click-modal="false"
			:title="dialogTitle"
			:visible.sync="showAddModal"
			v-if="showAddModal"
			append-to-body
		>
			<el-form 
				:model="dynamicValidateForm"
				ref="dynamicValidateForm"
				class="demo-dynamic form-item-w-100"
				status-icon
				:rules="rules"
				label-width="180px"
			>
			<el-form-item label="院校名称:" prop="collegename">
				<el-input v-model.trim="dynamicValidateForm.collegename" disabled />
				<el-button 
					type="primary" 
					class="select-btn" 
					@click="onSelectData(college_dialogresult, 'showAcademyModal')">选择</el-button>
			</el-form-item>
			<el-form-item label="函授站:" prop="schoolorgname">
			  <el-select
			    v-model="dynamicValidateForm.schoolorgname"
			    clearable
			    @change="onGuakaoschoolorChange"
			  >
			    <el-option
			      v-for="item in studyAddressList"
			      :key="item.key"
			      :value="item.key"
			      :label="item.val"
			    ></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="上课地点:" prop="classname">
			  <el-select
			    v-model="dynamicValidateForm.classname"
			    clearable
			    @change="onClassaddressChange"
			  >
			    <el-option
			      v-for="item in collegecoporgList"
			      :key="item.key"
			      :value="item.key"
			      :label="item.val"
			    ></el-option>
			  </el-select>
			</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
			  <el-button
			    type="primary"
			    @click="submitAddOrEditForm('dynamicValidateForm')"
			    :loading="!$store.state.global.isEndRequest"
			    >提交
			  </el-button>
			</span>
		</el-dialog>
		<!-- 院校列表 -->
		<el-dialog
		  class="btn-2b5a95"
		  title="院校列表："
			:close-on-click-modal='false'
		  :visible.sync="showAcademyModal"
		  v-if="showAcademyModal"
		  append-to-body
			@close="onCloseSelect"
		>
		  <el-button type="primary" @click="onConfirmAcademy">确定</el-button>
		
		  <div class="index_2 btn-2b5a95">
		    <div
		      class="l-w"
		      :style="{
		        height: $store.state.global.isSearchExtend_2
		          ? ''
		          : $store.state.global.searchFormHeight_2 + 10 + 'px',
		      }"
		    >
		      <el-form
		        label-position="right"
		        :class="
		          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
		        "
		        :model="selectSearchForm"
						@submit.native.prevent
		      >
		        <el-form-item label="院校名称:" prop="name">
		          <el-input 
								v-model.trim="selectSearchForm.name" 
								@keyup.enter.native="onSelectSearchClick(
		            selectTableUrl,
		            null,
		            Object.assign({}, selectSearchForm)
		          )"
								clearable />
		        </el-form-item>
		      </el-form>
		    </div>
		    <div class="r-w">
		      <el-button
		        type="primary"
		        icon="el-icon-search"
		        :loading="!$store.state.global.isEndRequest"
		        class="btn-2b5a95"
		        @click="
		          onSelectSearchClick(
		            selectTableUrl,
		            null,
		            Object.assign({}, selectSearchForm)
		          )
		        "
		        >搜索</el-button
		      >
					<el-button type="primary" @click="handleQuery">重置</el-button>
		      <el-button
		        type="primary"
		        :icon="
		          $store.state.global.isSearchExtend_2
		            ? 'el-icon-arrow-up'
		            : 'el-icon-arrow-down'
		        "
		        v-if="$store.state.global.searchExtend_2"
		        class="btn-2b5a95"
		        @click="onExtendClick('isSearchExtend_2')"
		        >{{ $store.state.global.searchExtendText_2 }}</el-button
		      >
		    </div>
		  </div>
		
		  <el-table
		    :data="selectTable.list"
		    style="width: 100%"
				stripe
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
		    @selection-change="handleSelectionChange"
		  >
		    <el-table-column type="selection" width="55" />
		    <el-table-column label="流水号" prop="id" align="center" />
		    <el-table-column label="院校名称" prop="name" align="center" />
		    <el-table-column label="学院编号" prop="code" align="center" />
		  </el-table>
		  <el-pagination
		    background
		    @current-change="
		      (val, data) =>
		        handleSelectChange(val, Object.assign({}, selectSearchForm))
		    "
		    :current-page="selectPageInfo.pageindex"
		    :page-size="selectPageInfo.pagesize"
		    :page-sizes="[10, 20, 30, 40, 50]"
		    layout="total, prev, pager, next, jumper"
		    :total="selectTable.totalcount"
		  ></el-pagination>
		</el-dialog>

    <Import
      :importDialog="importDialog"
      :importSaveUrl="collegecoporg_importsave"
      @onCloseImport="onCloseImport"
      @getDataList="getDataList"
      downloadUrl="download/教学管理/学历/校外教学点导入模板.xls"
    ></Import>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import Export from "@/components/Export/index.vue";
import Import from "@/components/Import/index.vue";

import {
  collegecoporg_list,
  collegecoporg_importsave,
  collegecoporg_delete,
	college_dialogresult,
	collegecorg_save,
	collegecoporg_input,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import { _pictureupload_save, _org_comboxguakaoschool, } from "@/request/api/public";
import { _collegetype } from "@/assets/js/filedValueFlag";

export default {
  mixins: [part],
  name: "college",
  components: { Export, Import },
  props: {
    collegecoporg_importsave: {
      default: () => collegecoporg_importsave,
    },
		college_dialogresult: {
		  default: () => college_dialogresult,
		},
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!(value + "")) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
			selectSearchForm: {},
			selectPageInfo: {
			  pageindex: 1,
			  pagesize: 10,
			},
			studyAddressList: [], //函授站
			collegecoporgList:[],//上课地点
      collegetype: _collegetype, // 院校类型（1成考  3网络教育  4自考 ）
      enableflag: {
        1: "可用",
        0: "不可用",
      },
      transferDialog: false, //导出框
      importDialog: false, //导入框
      itemId: null, //首表格项id
      searchForm: {},
			showAcademyModal: false,
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, // 添加
      showDetailModal: false, // 查看详情
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        collegename: [{ trigger: "blur", message: "必填字段", required: true }],
        schoolorgname: [{ trigger: "blur", message: "必填字段", required: true }],
        classname: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题
      fds: new FormData(),
    };
  },
  created() {
    this.getDataList();
		this.collegecoporglist();
		this.org_comboxguakaoschool();
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    //关闭导入框
    onCloseImport(bool) {
      this.importDialog = bool;
    },
		selectQuery() {
			this.selectSearchForm = {
				name: null
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null);
		},
		reset() {
			this.searchForm = {
				collegename: null,
				
			}
		},
		//重置
		resetQuery() {
			this.reset();
			this.getDataList();
		},
		//添加
		btnAdd() {
			this.dialogTitle = "添加";
			this.showAddModal = true;
			this.dynamicValidateForm = {
				
			}
		},
		//修改 、
		btnEdit() {
			this.dialogTitle = "修改";
			selectCheck(this.multipleSelection, "修改", false, () => {
			  this.editRoutePage(this.multipleSelection[0].id);
			});
		},
		//修改路由页 api
		editRoutePage(id) {
		  myRequest({
		    url: collegecoporg_input,
		    data: {
		      id: id,
		    },
		  }).then((res) => {
		    if (res.data.code === "200") {
		      this.showAddModal = true;
		      this.dynamicValidateForm = res.data.data.vcollegecoporg;
		      delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
		      delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
		    }
		  });
		},
		//改变函授站 change
		onGuakaoschoolorChange(val) {
			this.dynamicValidateForm.schoolorgid = val;
		},
		//改变上课开班地点 change
		onClassaddressChange(val) {
		  this.dynamicValidateForm.classid = val;
		},
		//加载上课地点 api
		collegecoporglist() {
		  myRequest({
		    url: _org_comboxguakaoschool,
		    data: {
		    },
		  }).then(res=>{
		    if(res.data.code==='200'){
					this.collegecoporgList = res.data.data.options;
		    }
		  })
		},
		//函授站 api
		org_comboxguakaoschool() {
		  myRequest({
		    url: _org_comboxguakaoschool,
		    data:{
		    }
		  }).then((res) => {
		    if (res.data.code === "200") {
		     this.studyAddressList = res.data.data.options;
		    }
		  });
		},
		//提交-（添加，修改） api
		submitAddOrEditForm(formName) {
		  this.$refs[formName].validate((valid) => {
		    if (valid) {
		      myRequest(
		        {
		          url: collegecorg_save,
		          data: this.dynamicValidateForm,
		        },
		        {
		          isRefTableList: true,
		          that: this,
		
		          modal: "showAddModal",
		        }
		      );
		    }
		  });
		},
		//确认院校 click
		onConfirmAcademy() {
		  selectCheck(this.multipleSelection, "确认院校", false, () => {
		   this.$set(
		      this.dynamicValidateForm,
		      "collegename",
		      this.multipleSelection[0].name
		    );
		    this.dynamicValidateForm.collegeid = this.multipleSelection[0].id;
		    this.showAcademyModal = false;
				this.handleQuery();
		  });
		},
		//关闭选项框 click
		onCloseSelect() {
		  this.selectPageInfo.pageindex = 1;
		},
    //导入 click
    btnImport() {
      this.importDialog = true;
    },
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: collegecoporg_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
		//切换选项表格页
		handleSelectChange(val, data) {
		  this.selectPageInfo.pageindex = val;
		  this.onSelectData(this.selectTableUrl, null, data);
		},
		onSelectData(url, modal, data) {
		  this.selectTableUrl = url;
		  myRequest({
		    url: this.selectTableUrl,
		    data: Object.assign(data || {}, this.selectPageInfo),
		  }).then((res) => {
		    if (res.data.code === "200") {
		      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
		      this.selectTable = res.data.data;
		      this[modal] = true;
		    }
		  });
		},
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
		//选项表格 - 搜索 click
		onSelectSearchClick(url, modal, data) {
		  this.selectPageInfo.pageindex = 1;
		  this.onSelectData(url, modal, data);
		},
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 查看详情路由页 api
    btnShowDetail(row) {
      myRequest({
        url: college_show,
        data: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showDetailModal = true;
          this.dialogTitle = "查看";
          this.dynamicValidateForm = res.data.data;
        }
      });
    },

    
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    
    //刷新 click
   btnRefresh() {
      this.getDataList();
    },
    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: collegecoporg_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
</style>